import React from "react";
import ReactCompareImage from "react-compare-image";
import implantBeforeImg from "../../secondAssets/Images/implantBeforeImg.jpeg"
import implantAfterImg from "../../secondAssets/Images/implantAfterImg.jpeg"
import { BeforeAfterCavitiesSection } from "../../SecondComponents";
import cavitiesBefore1 from "../../secondAssets/Images/cavitiesBefore1.jpeg";
import cavitiesAfter1 from "../../secondAssets/Images/cavitiesAfter1.jpeg";
import cavitiesBefore2 from "../../secondAssets/Images/cavitiesBefore2.jpeg";
import cavitiesAfter2 from "../../secondAssets/Images/cavitiesAfter2.jpeg";
import cavitiesBefore3 from "../../secondAssets/Images/cavitiesBefore3.jpeg";
import cavitiesAfter3 from "../../secondAssets/Images/cavitiesAfter3.jpeg";
import { FaVideo } from "react-icons/fa";

const BeforeAfter = (props) => {
    const { selectedLanguage } = props;
    const before = implantBeforeImg;
    const after = implantAfterImg;

    return (
        <div className="main">
            <div className="second-design-service-container">
                <div className="service-top-div">
                    <div>
                        <h1>{selectedLanguage?.txt_before_after}</h1>
                    </div>
                </div>
                <div className="about-dental-Implants-section about-before-after-dental-Implants-section about-before-after-dental-Implants-second-section">
                    <div
                        data-aos="fade-right"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                        <h1>{selectedLanguage?.txt_dental} <span>{selectedLanguage?.txt_implants}</span></h1>
                        <p className="before-after-text">{selectedLanguage?.txt_before_after_dental_implants}</p>
                        <div className="before-after-doctor-name-div">
                            <span className="before-after-doctor-name">{selectedLanguage?.txt_doctor_dr_hennah_krish}</span>
                            <span className="before-after-doctor-name">{selectedLanguage?.txt_patient_sean_bush}</span>
                            <span className="before-after-doctor-name">{selectedLanguage?.txt_diagnosis_missing_tooth}</span>
                        </div>
                    </div>
                    <div data-aos="fade-left"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                        <ReactCompareImage leftImage={before} rightImage={after} />
                    </div>
                </div>
                <div className="about-dental-Implants-section about-before-after-dental-Implants-section  about-before-after-dental-Implants-second-section">
                    <div data-aos="fade-right"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                        <BeforeAfterCavitiesSection cavitiesBefore1={cavitiesBefore1} cavitiesBefore2={cavitiesBefore2} cavitiesBefore3={cavitiesBefore3} cavitiesAfter1={cavitiesAfter1} cavitiesAfter2={cavitiesAfter2} cavitiesAfter3={cavitiesAfter3} />
                    </div>
                    <div data-aos="fade-left"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                        <h1>{selectedLanguage?.txt_root_cause} <span>{selectedLanguage?.txt_cavities}</span></h1>
                        <p className="before-after-text">{selectedLanguage?.txt_before_after_dental_implants}</p>
                        <div className="before-after-doctor-name-div">
                            <span className="before-after-doctor-name">{selectedLanguage?.txt_doctor_dr_anagha_menen}</span>
                            <span className="before-after-doctor-name">{selectedLanguage?.txt_patient_alton_pittman}</span>
                            <span className="before-after-doctor-name">{selectedLanguage?.txt_diagnosis_early_stage_cavities}</span>
                        </div>
                    </div>
                </div>
                <div className="about-dental-Implants-section about-before-after-dental-Implants-section">
                    <div
                        data-aos="fade-right"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                        <h1>{selectedLanguage?.txt_white}  <span>{selectedLanguage?.txt_fillings}</span></h1>
                        <p className="before-after-text">{selectedLanguage?.txt_before_after_dental_implants}</p>
                        <div className="before-after-doctor-name-div">
                            <span className="before-after-doctor-name">{selectedLanguage?.txt_doctor_dr_bora_tumnus}</span>
                            <span className="before-after-doctor-name">{selectedLanguage?.txt_patient_roy_ramirez}</span>
                            <span className="before-after-doctor-name">{selectedLanguage?.txt_diagnosis_bonding_broken_teeth}
                            </span>
                        </div>
                    </div>
                    <div
                        data-aos="fade-left"
                        data-aos-easing="ease-out-bounce"
                        data-aos-delay="300"
                        data-aos-duration="2000">
                        <BeforeAfterCavitiesSection cavitiesBefore1={cavitiesBefore1} cavitiesBefore2={cavitiesBefore2} cavitiesBefore3={cavitiesBefore3} cavitiesAfter1={cavitiesAfter1} cavitiesAfter2={cavitiesAfter2} cavitiesAfter3={cavitiesAfter3} />
                    </div>
                </div>
            </div>
            <div className="about-bottom-section-main before-after-bg-section">
                <div className="about-bottom-section-main-overlay">
                    <div className="before-after-bg-section-container">
                        <div className="before-after-bg-section-text-div"
                            data-aos="fade-right"
                            data-aos-easing="ease-out-bounce"
                            data-aos-delay="300"
                            data-aos-duration="2000">
                            <h1>{selectedLanguage?.txt_planning_dental_implants}</h1>
                            <h2>{selectedLanguage?.txt_complete_dentures}</h2>
                            <p>{selectedLanguage?.txt_i_am_a_text_block}</p>
                        </div>
                        <div data-aos="fade-left"
                            data-aos-easing="ease-out-bounce"
                            data-aos-delay="300"
                            data-aos-duration="2000" className="before-after-bg-section-button-div">
                            <button><FaVideo /></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BeforeAfter;



